import React, { ReactNode } from "react"
import styles from "./InfoIcon.module.scss"
import { faQuestionCircle } from "@fortawesome/pro-solid-svg-icons/faQuestionCircle"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import PopoverTrigger from "../PopoverTrigger/PopoverTrigger"
import { Placement } from "react-bootstrap/Overlay"
import { SizeProp } from "@fortawesome/fontawesome-svg-core"
import cn from "classnames"

export interface InfoIconProps {
    id: string
    title?: string
    content: ReactNode | string
    placement?: Placement
    size?: SizeProp
    className?: string
}

const InfoIcon = (props: InfoIconProps) => {
    const { placement = "top", size, className } = props

    return (
        <PopoverTrigger {...props} placement={placement}>
            <FontAwesomeIcon icon={faQuestionCircle} className={cn(styles.infoIcon, className)} size={size} />
        </PopoverTrigger>
    )
}

export default InfoIcon
